import { gql } from '@apollo/client';

export const QUERY_WEBHOOK_EVENT_TYPES = gql`
  query QueryWebhookEventTypes {
    webhookEventTypes: webhook_event_types {
      value
      comment
    }
  }
`;
